import faqs from "./faqs";
import notifications from "./notifications";

export default {
    faqs,
    notifications
};
